import { FC } from 'react';

import { Stack, Typography } from 'libs/ui';
import { Icon as UiIcon } from 'libs/ui/Icon';
import { SvgProps } from 'libs/ui/Icon/icons/types';

import { NavigationLinkStyled } from './LinkField.styles';

export interface LinkFieldProps {
  label: string;
  value: string;
  link: string;
  Icon?: FC<SvgProps>;
}

export const LinkField = ({ label, value, link, Icon }: LinkFieldProps) => (
  <Stack spacing={4}>
    <Typography className="client-label" variant="caption">
      {label}
    </Typography>
    <NavigationLinkStyled to={link}>
      {Icon && <Icon size={16} />}
      <Typography className="client-name ellipsisText" variant="bodyMedium">
        {value}
      </Typography>
      <UiIcon.ChevronRight size={20} />
    </NavigationLinkStyled>
  </Stack>
);
